module.exports = __webpack_public_path__ + "static/Team5-8af9a204aa5f8a0ebf278ef057076d63.png";